<template>
  <section>
    <!-- <b-button v-b-modal.import-company-part-modal size="sm" variant="primary">
      <i class="fa fa-plus mr-1" aria-hidden="true"></i>Import Company Parts
    </b-button> -->
    <b-modal
      id="import-company-part-modal"
      ref="import-company-part-modal"
      size="sm"
      @shown="logStatus = 'Waiting for files to be imported...'; onImporting = true"
      @hide="$bvModal.hide('import-company-part-modal')"
      title="Import Company Part"
      no-close-on-backdrop
    >
      <div class="modal-body">
        <a href="/files/CompanyPartNumberImportFile.xlsx" download>
          <i class="fa fa-file"></i>
          Download Template File
        </a>
        <b-form-group label="Company" class="required mt-2">
          <b-input-group>
            <b-input-group-append v-if="!companyInfo && (checkClaim(CAN_ADD_COMPANY) || checkClaim(CAN_EDIT_COMPANY))">
              <b-button variant="light" @click="$refs.addNewCompanyForExcess.showModal()">
                <i v-if="checkClaim(CAN_ADD_COMPANY)" v-show="this.formData.companyId == undefined || this.formData.companyId == null || this.formData.companyId == 0" class="customer-lookup--plus fa fa-plus"></i>
                <i v-if="checkClaim(CAN_EDIT_COMPANY)" v-show="this.formData.companyId > 0" class="customer-lookup--plus fa fa-pencil"></i>
              </b-button>
            </b-input-group-append>
            <vue-simple-suggest
              :disabled="(companyInfo) ? true : false"
              class="suggest-input form-control"
              :class="{ 'is-invalid': $v.formData.companyId.$error }"
              :styles="autoCompleteStyle"
              :list="getListOfNames"
              :max-suggestions="20"
              :min-length="3"
              :debounce="200"
              :filter-by-query="true"
              value-attribute="id"
              display-attribute="name"
              v-model="chosenName"
              @select="onSuggestNameSelect"
              @input="suggestNameChange"
              @blur="$v.formData.companyId.$touch()"
              @request-done="isLoading=!isLoading"
            >
              <div slot="misc-item-below" v-if="isLoading" class="misc-item">
                <span>Loading company...</span>
              </div>
            </vue-simple-suggest>
            <b-form-invalid-feedback>Please select a company</b-form-invalid-feedback>
          </b-input-group>
        </b-form-group>
        <b-form-group label="Company Part Import File" class="required mt-2">
          <b-form-file
            multiple
            v-model="formData.filesUpload"
            :disabled="isSaving || !onImporting"
            :file-name-formatter="formatNames"
            accept=".xlsx"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
          ></b-form-file>
          <b-form-invalid-feedback>Please select valid file to import parts.</b-form-invalid-feedback>
        </b-form-group>
        <br/>
        <b-form-group>
          <b-textarea
            v-model="logStatus"
            disabled
            :style="`width: 100%`"
            :rows="5"
          />
        </b-form-group>
      </div>
      <template slot="modal-footer">
          <b-button @click="$bvModal.hide('import-company-part-modal')">Close</b-button>
          <b-button variant="primary" @click="onImportCompanyParts" v-if="onImporting" :disabled="isSaving">Import</b-button>
      </template>
    </b-modal>
    <edit-company
      ref="addNewCompanyForExcess"
      hiddenButton
      :id="formData.companyId"
      :modalId="'add-new-company-for-excess'"
      :companyName="chosenName"
      @currentCompany="onCurrentCompany"
      @cancel="chosenName = ''"
    />
  </section>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  import VueSimpleSuggest from 'vue-simple-suggest';
  import { required } from 'vuelidate/lib/validators';
  import { AUTO_COMPLETE_STYLES } from '@/shared/constants';
  import accountDocumentService from '@/pages/Company/components/CompanyDetails/tabs/Documents/service';
  import EditCompany from '@/pages/Company/components/EditCompany';

  export default {
    components: {
      VueSimpleSuggest,
      EditCompany
    },
    props: {
      companyInfo: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        chosenName: (this.companyInfo)? this.companyInfo.name : '',
        autoCompleteStyle: AUTO_COMPLETE_STYLES,
        isLoading: false,
        isSaving: false,
        formData: {
          companyId: (this.companyInfo)? this.companyInfo.id : 0,
          filesUpload: null,
        },
        logStatus: null,
        onImporting: false,
        accountDocumentService
      };
    },
    validations: {
      formData: {
        companyId: { required },
        filesUpload: { required },
      },
    },
    computed: {},
    methods: {
      ...mapActions('companies', ['getByNameAndAccountType']),
      ...mapActions('companyParts', ['importCompanyPart']),
      async onSuggestNameSelect(suggestion) {
        this.formData.companyId = suggestion.id;
      },
      async suggestNameChange(val) {
        this.isLoading = true;
        if (val === '' || val !== this.chosenName) {
          this.formData.companyId = '';
        }
      },
      async getListOfNames(name) {
        return await this.getByNameAndAccountType({ typeId: 0, name });
      },
      formatNames(files) {
        return files[0].name;
      },
      onClickForm() {
        if (this.companyInfo.class > 0) {
          this.$bvModal.show('import-company-part-modal');
        } else {
          this.openAlertBox({ message: `This company doesn't have an Account Class defined to determine as the Inventory Source. Please update the Company to add the Account Class` });
        }
        
      },     
      async onImportCompanyParts(e) {
        e.preventDefault();
        this.$v.formData.$touch();
        if (this.$v.formData.$invalid) {
          return;
        }
        let formData = new FormData();
        this.formData.filesUpload.forEach(element => {
          formData.append('files[]', element, element.name);
        });
        formData.append('companyId', this.formData.companyId);
        this.isSaving = true;
        this.logStatus += `\nStarted importing company parts...`
        const result = await this.importCompanyPart(formData).catch(() => {
          this.isSaving = false;
          this.formData.filesUpload = null;
          this.logStatus += `\nThere's an error encountered during import. Please check errors within the import file.`
        });

        if (result != null) {
          
          this.logStatus += `\n---------------------------------------------------------`
          this.logStatus += `\nSuccessfully imported company parts: ${result.successCount}`
          this.logStatus += `\nFailed imported company parts: ${result.failCount}`
          if (this.formData.companyId > 0)
            this.accountDocumentService.getAll(this.formData.companyId);
        }

        this.isSaving = false;
        this.onImporting = false;
        // this.$bvModal.hide(this.modalId);
        this.$emit('refreshGrid');
      },
      async onCurrentCompany(val) {
        this.formData.companyId = val.id;
        this.chosenName = val.name;
      },
    },
  };
</script>
